<template>
  <div class="increase__input el-input-number base-input-number" :class="{ 'is-disabled border-gray-150': disabled }">
    <span
      role="button"
      class="el-input-number__increase text-base font-bold"
      :class="{ 'is-disabled': disabled || formValue >= (maxValue || 999) }"
      @click="increase"
    >
      <span class="mdi mdi-plus" aria-hidden="true"> </span>
    </span>
    <span
      role="button"
      class="el-input-number__bottom-decrease text-base font-bold el-input-number__increase"
      :class="{ 'is-disabled': disabled || formValue <= (minValue || 0) }"
      @click="decrease"
    >
      <span class="mdi mdi-minus" aria-hidden="true"> </span>
    </span>
    <div class="el-input" :class="{ 'is-disabled ': disabled }">
      <el-input
        inputmode="numeric"
        type="text"
        :value="formValue"
        :maxlength="maxlength"
        :disabled="disabled"
        @blur="onBlur"
        @input="onInput"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: [Number, String], default: () => 1 },
    maxlength: { type: [Number], default: () => 3 },
    disabled: { type: Boolean, default: () => false },
    maxValue: { type: [Number, String], default: () => null },
    minValue: { type: [Number, String], default: () => null },
    defaultValue: { type: Number, default: () => 1 },
  },
  computed: {
    formValue: {
      get() {
        return this.value
      },
      set(val) {
        this.value = val
      },
    },
  },
  methods: {
    increase(event) {
      if ((!event.detail || event.detail == 1) && this.formValue < (this.maxValue || 999)) {
        this.$emit('input', Number(this.formValue) + 1)
      }
    },
    decrease(event) {
      if ((!event.detail || event.detail == 1) && this.formValue > (this.minValue || 0)) {
        this.$emit('input', Number(this.formValue) - 1)
      }
    },
    onBlur() {
      if (isNaN(this.formValue) || Number(this.formValue) <= 0) {
        this.$emit('input', this.defaultValue)
      }
      if (this.maxValue && this.formValue > this.maxValue) {
        this.$emit('input', Number(this.maxValue))
      }
      if (this.minValue && this.formValue < this.minValue) {
        this.$emit('input', Number(this.minValue))
      }
    },
    onInput(value) {
      if (value !== '' && value !== null) {
        if (Number(value) <= 0) {
          this.$emit('input', this.defaultValue)
        } else if (this.maxValue && Number(value) > this.maxValue) {
          this.$emit('input', Number(this.maxValue))
        } else if (this.minValue && Number(value) < this.minValue) {
          this.$emit('input', Number(this.minValue))
        } else {
          this.$emit('input', Number(value))
        }
      } else {
        this.formValue = value
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/components/base-input-number.scss';
</style>
